<template>
  <header class="st-navbar">
    <nav class="navbar navbar-default navbar-fixed-top clearfix" :class="{'white-header': scroll}" role="navigation">
      <!-- Brand and toggle get grouped for better mobile display -->
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#sept-main-nav">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="#" v-if="scroll"><img src="../assets/img/logo.png" alt=""
                                                              class="img-responsive"></a>
          <a class="navbar-brand" href="#" v-else><img src="../assets/img/logoWhite.png" alt="" class="img-responsive"></a>
        </div>
        <div class="collapse navbar-collapse main-nav" id="sept-main-nav">
          <ul class="nav navbar-nav navbar-left">
            <li :class="{'active': $route.path == '/'}"><a href="#/">首页</a></li>
            <li :class="{'active': $route.path == '/productCenter' || $route.path == '/drive' || $route.path == '/fordinner' ||
                                   $route.path == '/store' || $route.path == '/materiel' || $route.path == '/kds'}">
              <a href="#/productCenter">产品中心</a>
            </li>
            <li :class="{'active': $route.path == '/industryConsult' |  $route.path == '/consult'}">
              <a href="#/industryConsult">行业资讯</a>
            </li>
            <li :class="{'active': $route.path == '/businessIntroduction'}"><a href="#/businessIntroduction">业务介绍</a>
            </li>
            <li :class="{'active': $route.path == '/aboutUs'}"><a href="#/aboutUs">关于我们</a></li>
          </ul>
          <ul class="nav navbar-nav navbar-right">
            <span class="login login-active" ><a href="#/login">登录</a></span>
            <span class="register"><a href="#/register">注册</a></span>
            <!--<li class="login"><a href="#/login">登录</a></li>-->
            <!--<li class="register">-->
              <!--<a href="#/register">注册</a>-->
            <!--</li>-->
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'header',
  data() {
    return {
      scroll: false
    }
  },
  created() {

  },
  mounted() {
    window.addEventListener('scroll', this.menu)
  },
  methods: {
    menu() {
      if (window.scrollY >= 50) {
        this.scroll = true
      } else {
        this.scroll = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .navbar-default .navbar-nav > li.active > a {
    font-weight: 500;
  }

  .white-header .navbar-nav > li > a {
    color: #383838;
    opacity: 0.8;
    font-weight: 400;
  }

  .navbar-default .navbar-nav > li > a {
    font-weight: 400;
  }

  .white-header .navbar-nav > li.active > a {
    color: #0174F4 !important;
  }

  .white-header {
    opacity: 0.9;
  }

  .navbar-left {
    margin-left: 100px;
  }

  /*.navbar-right {*/
    /*height: 100px;*/
    /*line-height: 100px;*/
  /*}*/

  .login {
    a{
      width: 88px;
      height: 34px !important;
      line-height: 34px;
      background: rgba(255, 255, 255, 0.14);
      border-radius: 18px;
      border: 1px solid rgba(255, 255, 255, 0.5);
      display: inline-block;
      text-align: center;
      font-size: 13px;
      color: rgba(255, 255, 255, 1);
      margin-top: 30px;
    }
  }

  .register {
    a{
      width: 88px;
      height: 34px !important;
      line-height: 34px;
      background: rgba(255, 255, 255, 0);
      border-radius: 18px;
      border: 1px solid rgba(255, 255, 255, 0.5);
      display: inline-block;
      text-align: center;
      font-size: 13px;
      color: rgba(255, 255, 255, 1);
      margin-left: 10px;
    }
  }
  .white-header .login a, .white-header .register a{
    color: #383838!important;
    border: 1px solid #E2E2E2;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue